import React, { useState } from "react";
import { Grid, TextField, Button, Typography, Box, FormHelperText, Snackbar, Alert } from "@mui/material";
import axios from "axios";

const DeleteAccount = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    message: "",
  });
  const serverURL = process.env.REACT_APP_URL;
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle phone number input (numeric only)
    if (name === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length > 10) return; // Limit to 10 digits
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

 

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required.";
    } else if (formData.phoneNumber.length !== 10) {
      newErrors.phoneNumber = "Phone number must be 10 digits.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Reason is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = async() => {
              try {
                const response = await axios.post(`${serverURL}/contactUs/create`, {
                formData
                });

                console.log(response.data)
                if(response?.data?.success){
                setSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: "success",
                  });
                  setFormData({
                    name: "",
                    phoneNumber: "",
                    message: "",
                  })
                }else{
                    setSnackbar({
                        open: false,
                        message: "Something went wrong",
                        severity: "error",
                      });
                }
              } catch (err) {
                console.error(err);
                setSnackbar({
                    open: false,
                    message: "Something went wrong",
                    severity: "error",
                  });
              }


  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      sendEmail();
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "2rem",
        textAlign: "center",
        marginTop: "8rem",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          marginBottom: "1rem",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: "#aaa",
          fontSize: "12px",
        }}
      >
        Account
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          marginBottom: "4rem",
          fontSize: "30px",
        }}
      >
       Delete your Pixell Account
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Name Field */}
          <Grid item xs={12} sm={6} lg={6}>
            <Box sx={{ textAlign: "left" }}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  marginBottom: "6px",
                  display: "block",
                  color: errors.name ? "red" : ""
                }}
              >
                Name*
              </label>
              <TextField
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
                error={!!errors.name}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "12px",
                  },
                }}
              />
              {errors.name && (
                <FormHelperText sx={{ color: "var(--error-color)" }}>
                  {errors.name}
                </FormHelperText>
              )}
            </Box>
          </Grid>

          {/* Phone Number Field */}
          <Grid item xs={12} sm={6} lg={6}>
            <Box sx={{ textAlign: "left" }}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  marginBottom: "6px",
                  display: "block",
                  color: errors.phoneNumber? "red" : ""
                }}
              >
                Phone Number*
              </label>
              <TextField
                fullWidth
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                type="phoneNumber"
                variant="outlined"
                error={!!errors.phoneNumber}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "12px",
                  },
                }}
              />
              {errors.phoneNumber && (
                <FormHelperText sx={{ color: "var(--error-color)" }}>
                  {errors.phoneNumber}
                </FormHelperText>
              )}
            </Box>
          </Grid>

          {/* Message Field */}
          <Grid item xs={12}>
            <Box sx={{ textAlign: "left" }}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  marginBottom: "6px",
                  marginTop: "2rem",
                  display: "block",
                  color: errors.message? "red" : ""
                }}
              >
                Reason*
              </label>
              <TextField
                fullWidth
                name="message"
                value={formData.message}
                onChange={handleChange}
                variant="outlined"
                multiline
                rows={4}
                error={!!errors.message}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "12px",
                  },
                }}
              />
              {errors.message && (
                <FormHelperText sx={{ color: "var(--error-color)" }}>
                  {errors.message}
                </FormHelperText>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Box sx={{ textAlign: "left", marginTop: "2rem" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#007bff",
              color: "#fff",
              borderRadius: "10px",

              padding: "0.5rem 1rem",
              fontWeight: "bold",
              textTransform: "none",
              "&:hover": { backgroundColor: "#0056b3" },
            }}
          >
            Submit ➞
          </Button>
        </Box>
      </form>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DeleteAccount;
